export default "__VITE_ASSET__GcVdzXEa__"